import DomainCommon from './common'

const UserService = {
    login: ({email, password}) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPost({
                url: `${DomainCommon.getUecareApiUrl()}/login`,
                jsonBody: {email, password},
                resolve, reject
            })
        })
    },
    loginWithApiToken: ({apiToken}) => {
        return new Promise((resolve, reject) => {
            DomainCommon.setApiToken(apiToken);
            return DomainCommon.fetchPost({
                url: `${DomainCommon.getUecareApiUrl()}/ui/user`,
                resolve, reject
            })
        })
    },
    findById: (userId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/user/${userId}`,
                resolve, reject
            })
        })
    },
    list: () => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/user`,
                resolve, reject
            })
        })
    },
    avatarGetUrl: ({base64Image}) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPost({
                url: `${DomainCommon.getUecareApiUrl()}/ui/image/url`,
                jsonBody: {base64_src: base64Image},
                resolve, reject
            });
        });
    },
    sendCustomMail: ({ userId, subject, content }) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPost({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/user/${userId}/sendCustomMail`,
                jsonBody: { subject, content },
                resolve, reject,
            })
        })
    },
    changePassword: ({ newPassword }) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/user/changePassword`,
                jsonBody: {password: newPassword},
                resolve, reject
            });
        });
    },

};

export default UserService;



// WEBPACK FOOTER //
// ./src/service/user.js